"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAllWithRegex = void 0;
/**
 * Use a regex with the global flag to find all matches and return the list of matches with match groups mapped to parameter names
 * @param regex - The regex definition and match attributes
 * @param text - The text to find all in
 * @returns The matches all converted to type T
 */
function findAllWithRegex(regex, text) {
    // Validate the parameters
    if (!regex.value.flags.includes('g')) {
        throw new Error('Regex.value must have a g flag');
    }
    // The name of the match groups
    const matchParams = ['fullMatch', ...regex.matches];
    // The results
    const results = [];
    // Check for initial match
    let match = regex.value.exec(text);
    let i = 0;
    // Loop over all matches
    while (match) {
        // Ensure that each match is accounted for
        if (matchParams.length !== match.length && !regex.skipMatchValidation) {
            throw new Error(`Mismatch in match length at index [${i}]: "${match.length}" vs expected: "${matchParams.length}"`);
        }
        // Construct the match result and assert it is of type T & RegExpMatch
        const result = match.reduce((acc, matchResult, ind) => Object.assign(acc, { [matchParams[ind]]: matchResult }), {});
        // Save the index
        result.matchIndex = match.index;
        // Test if the strict regex passes
        if (regex.strict) {
            result.isStrict = regex.strict.test(result.fullMatch);
        }
        // Save the result
        results.push(result);
        // Check for another
        match = regex.value.exec(text);
        i += 1;
    }
    return results;
}
exports.findAllWithRegex = findAllWithRegex;
//# sourceMappingURL=findAllWithRegex.js.map